import React, { useState } from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import { NoteDTO, HistoryDTO } from 'common/utils/util.type';
import { NotesAccordion } from './Notes/NotesAccordion';
import { addOrUpdateNoteToProject, deleteNoteFromProject, getNotes } from '../project/project.api';
import HistoryAccordion from './HistoryAccordion';
import FilesAccordion from './FilesAccordion';

interface ProjectMiscTabsProps {
  projectId: string;
  notes: NoteDTO[];
  setNotes: (notes: NoteDTO[]) => void;
  history?: HistoryDTO[];
  isLoadingHistory?: boolean;
  isSaving?: boolean;
  shouldRefetch?: boolean;
}

const ProjectMiscTabs: React.FC<ProjectMiscTabsProps> = ({
  projectId,
  notes,
  setNotes,
  history,
  isLoadingHistory,
  isSaving,
  shouldRefetch,
}) => {
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <Box sx={{ width: '100%', mt: 2 }}>
      <Tabs
        value={tabIndex}
        onChange={(_, newIndex) => setTabIndex(newIndex)}
        sx={{
          '.MuiTab-root': {
            '&:hover': {
              backgroundColor: '#eaf5f7',
            },
            fontWeight: 'bold',
          },
        }}
        aria-label='Notes and History Tabs'
      >
        <Tab label='Notes' />
        <Tab label='History' />
        <Tab label='Files' />
      </Tabs>

      {tabIndex === 0 && (
        <NotesAccordion
          entityId={projectId}
          notes={notes}
          setNotes={setNotes}
          apiCalls={{
            getNotes: getNotes,
            addOrUpdateNote: addOrUpdateNoteToProject,
            deleteNote: deleteNoteFromProject,
          }}
          shouldRefetch={shouldRefetch}
        />
      )}
      {tabIndex === 1 && <HistoryAccordion projectId={projectId} isSaving={isSaving} />}
      {tabIndex === 2 && <FilesAccordion projectId={projectId} />}
    </Box>
  );
};

export default ProjectMiscTabs;
